export default "__VITE_ASSET___app/immutable/assets/default-avatar-1.Ge7xELY6.svg__"